import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "@/api/useApiClient";
import { listNotifications } from "@/api";
import { cn } from "@/lib/cn";

export function NotificationBell() {
  const client = useApiClient();
  const navigate = useNavigate();
  const [count, setCount] = React.useState(0);

  const fetchCount = React.useCallback(async () => {
    try {
      const { data } = await listNotifications({
        client,
        query: { unread_only: true, limit: 10 },
        throwOnError: true,
      });
      setCount(data.items.length);
    } catch (err) {
      console.error("Failed to fetch unread notification count", err);
    }
  }, [client]);

  React.useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [fetchCount]);

  const displayCount = count > 9 ? "9+" : String(count);

  return (
    <button
      type="button"
      className="relative text-fg-muted hover:text-fg transition-colors focus-visible:outline-none"
      aria-label={`${count} unread notifications`}
      onClick={() => navigate("/inbox")}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      {count > 0 && (
        <span
          className={cn(
            "absolute -top-1 -right-1.5 min-w-3.5 h-3.5 px-0.5 bg-danger text-[8px] text-accent-fg flex items-center justify-center font-mono rounded-full scale-100 transition-transform duration-200"
          )}
        >
          {displayCount}
        </span>
      )}
    </button>
  );
}
